// src/pages/patient/PatientSignIn.jsx
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { safeReturnPath } from "../lib/returnPath";
import axios from "axios";
import { setAuthSession, isAuthenticated } from "../utils/authStore";

function classNames(...arr) {
  return arr.filter(Boolean).join(" ");
}

function Icon({ name, className = "h-5 w-5" }) {
  switch (name) {
    case "mail":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z"
            stroke="currentColor"
            strokeWidth="2.2"
          />
          <path
            d="m5.5 7.5 6.2 5a1 1 0 0 0 1.3 0l6.2-5"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "lock":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 10V8a5 5 0 0 1 10 0v2"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M6 10h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z"
            stroke="currentColor"
            strokeWidth="2.2"
          />
          <path
            d="M12 14v3"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "eye":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7Z"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 15.2A3.2 3.2 0 1 0 12 8.8a3.2 3.2 0 0 0 0 6.4Z"
            stroke="currentColor"
            strokeWidth="2.2"
          />
        </svg>
      );

    case "eyeOff":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M10.6 5.2A10.8 10.8 0 0 1 12 5c6 0 9.5 7 9.5 7a18 18 0 0 1-2.2 3.3"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M6.3 6.3C3.7 8.2 2.5 12 2.5 12s3.5 7 9.5 7c1.7 0 3.2-.3 4.5-.9"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M9.6 9.6A3.2 3.2 0 0 0 12 15.2"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <path
            d="M3 3l18 18"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "calendar":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 3v3M17 3v3M4 8h16"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
          <rect
            x="4"
            y="6"
            width="16"
            height="14"
            rx="2"
            stroke="currentColor"
            strokeWidth="2.2"
          />
        </svg>
      );

    case "heart":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M20.8 5.6a5.2 5.2 0 0 0-7.4 0L12 7l-1.4-1.4a5.2 5.2 0 0 0-7.4 7.4L12 21.7 20.8 13a5.2 5.2 0 0 0 0-7.4Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "shield":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 3 20 6v6c0 5-3.4 8.3-8 9-4.6-.7-8-4-8-9V6l8-3Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinejoin="round"
          />
          <path
            d="m8.8 12 2 2 4.6-5"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "users":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M16 19a4 4 0 0 0-8 0"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
          <path
            d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
            stroke="currentColor"
            strokeWidth="2.1"
          />
          <path
            d="M20 19a3 3 0 0 0-3-3M17 7.3a3 3 0 0 1 0 5.4M4 19a3 3 0 0 1 3-3M7 7.3a3 3 0 0 0 0 5.4"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
        </svg>
      );

    case "clock":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            strokeWidth="2.1"
          />
          <path
            d="M12 7v5l3 2"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "arrowRight":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M9 6l6 6-6 6"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return null;
  }
}

function Field({ label, children, right }) {
  return (
    <div>
      <div className="flex items-end justify-between gap-3">
        <label className="text-sm font-semibold text-slate-800">{label}</label>
        {right}
      </div>
      <div className="mt-2">{children}</div>
    </div>
  );
}

function FloatingCard({ className = "", children }) {
  return (
    <div
      className={classNames(
        "rounded-[28px] border border-slate-200/80 bg-white/90 p-4 text-slate-900 shadow-[0_24px_80px_rgba(15,23,42,0.12)] backdrop-blur-xl",
        className
      )}
    >
      {children}
    </div>
  );
}

function HeroFeature({ icon, title, text }) {
  return (
    <div className="flex gap-3">
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-blue-100 bg-blue-50 text-blue-700">
        <Icon name={icon} className="h-5 w-5" />
      </div>
      <div>
        <div className="text-sm font-extrabold text-slate-950">{title}</div>
        <div className="mt-1 text-xs leading-5 text-slate-500">{text}</div>
      </div>
    </div>
  );
}

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "http://ec2-34-228-161-76.compute-1.amazonaws.com:8001";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default function PatientSignIn() {
  const navigate = useNavigate();
  const location = useLocation();
  // The AppShell guard records the protected page the patient tried to open.
  const returnPath = safeReturnPath(location.state?.from);
  const [showPw, setShowPw] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [form, setForm] = useState({
    email: "",
    password: "",
    remember: true,
  });

  const input =
    "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-primary focus:ring-4 focus:ring-primary/10 disabled:bg-slate-50 disabled:text-slate-500";
  const inputWithIcon = classNames(input, "pl-12");

  React.useEffect(() => {
    if (isAuthenticated()) {
      navigate(returnPath, { replace: true });
    }
  }, [navigate, returnPath]);

  React.useEffect(() => {
    const testConnection = async () => {
      try {
        await api.get("/health");
        console.log("API connection successful");
      } catch (error) {
        console.warn("API may not be accessible:", error.message);
      }
    };

    testConnection();
  }, []);

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!form.email || !form.email.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }

    if (!form.password || form.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setIsLoading(true);

    try {
      const response = await api.post("/api/v1/patients/login", {
        email: form.email.trim(),
        password: form.password,
      });

      const { access_token, token_type, patient } = response.data;

      if (!access_token) {
        throw new Error("No access token received from server.");
      }

      if (token_type !== "bearer") {
        console.warn(`Unexpected token type: ${token_type}`);
      }

      const authSession = {
        access_token,
        token_type,
        patient,
        email: form.email,
        remember: form.remember,
        timestamp: new Date().toISOString(),
      };

      setAuthSession(authSession);
      api.defaults.headers.common.Authorization = `Bearer ${access_token}`;

      setSuccess("Sign in successful. Redirecting...");

      setTimeout(() => {
        navigate(returnPath, { replace: true });
      }, 900);
    } catch (error) {
      console.error("Login error:", error);

      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;

        if (status === 422 && Array.isArray(errorData.detail)) {
          setError(errorData.detail.map((err) => err.msg).join(", "));
        } else if (status === 401) {
          setError("Invalid email or password.");
        } else if (status === 404) {
          setError("Login endpoint not found. Please check the API URL.");
        } else if (status >= 500) {
          setError("Server error. Please try again later.");
        } else {
          setError(
            errorData.detail ||
              errorData.message ||
              errorData.error ||
              `Sign in failed. Status: ${status}`
          );
        }
      } else if (error.request) {
        setError("No response from server. Please check your internet connection.");
      } else {
        setError(`Sign in failed: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <main className="h-screen overflow-hidden bg-slate-50">
      <div className="grid h-screen grid-cols-1 lg:grid-cols-12">
        {/* LEFT VISUAL SIDE */}
        <section className="relative hidden h-screen overflow-hidden bg-white lg:col-span-7 lg:block">
          <div className="absolute -left-28 bottom-[-140px] h-[420px] w-[420px] rounded-full bg-blue-200/45 blur-3xl" />
          <div className="absolute right-[-120px] top-[-120px] h-[360px] w-[360px] rounded-full bg-cyan-200/45 blur-3xl" />
          <div className="absolute left-[58%] top-[18%] h-[240px] w-[240px] rounded-full bg-violet-200/35 blur-3xl" />

          {/* decorative grid */}
          <div className="absolute inset-0 opacity-[0.42]">
            <svg className="h-full w-full" viewBox="0 0 900 900" fill="none">
              <defs>
                <pattern
                  id="grid"
                  width="44"
                  height="44"
                  patternUnits="userSpaceOnUse"
                >
                  <path
                    d="M44 0H0V44"
                    stroke="#2563EB"
                    strokeWidth="1"
                    opacity="0.16"
                  />
                </pattern>
              </defs>
              <rect width="900" height="900" fill="url(#grid)" />
            </svg>
          </div>

          {/* pulse lines */}
          <svg
            className="absolute left-[6%] top-[22%] h-[280px] w-[88%] opacity-35"
            viewBox="0 0 900 260"
            fill="none"
          >
            <path
              d="M0 145 C110 80 190 80 280 140 C350 188 410 185 455 110 L480 210 L515 65 L545 148 C590 145 620 145 675 110 C760 55 835 50 900 80"
              stroke="#2563EB"
              strokeWidth="3"
              strokeLinecap="round"
            />
            <path
              d="M0 176 C120 130 215 125 310 166 C405 205 490 205 585 158 C710 96 805 96 900 122"
              stroke="#06B6D4"
              strokeWidth="1.8"
              strokeLinecap="round"
              opacity="0.55"
            />
          </svg>

          {/* plus dots */}
          <div className="absolute left-[60%] top-[12%] text-4xl font-black text-blue-200">
            +
          </div>
          <div className="absolute right-[9%] top-[32%] text-5xl font-black text-cyan-200">
            +
          </div>
          <div className="absolute left-[48%] bottom-[21%] text-3xl font-black text-violet-200">
            +
          </div>

          <div className="relative z-10 flex h-screen flex-col px-10 py-9 xl:px-14">
            {/* logo */}
            <div className="flex items-center gap-4">
              <img
                src="/images/logo.png"
                alt="ThePulseCare"
                className="h-14 w-auto object-contain"
              />
              <div>
                <div className="text-2xl font-extrabold tracking-tight text-slate-950">
                  ThePulseCare
                </div>
                <div className="text-sm font-bold text-slate-500">
                  Patient Portal
                </div>
              </div>
            </div>

            <div className="mt-20 max-w-2xl">
              <h1 className="text-6xl font-black leading-[0.98] tracking-tight text-slate-950 xl:text-7xl">
                Your care
                <br />
                journey
                <br />
                <span className="bg-gradient-to-r from-blue-700 via-sky-500 to-cyan-500 bg-clip-text text-transparent">starts here</span>
              </h1>

              <p className="mt-7 max-w-xl text-lg leading-8 text-slate-600">
                Find trusted doctors, book appointments, complete forms, and
                manage your health visits securely from one modern portal.
              </p>
            </div>

            {/* floating cards */}
            <FloatingCard className="absolute right-[11%] top-[22%] w-[275px]">
              <div className="text-xs font-bold text-slate-500">
                Upcoming appointment
              </div>
              <div className="mt-3 flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-50 text-blue-700">
                  <Icon name="calendar" className="h-6 w-6" />
                </div>
                <div>
                  <div className="text-sm font-black text-slate-950">Dr. Sarah Mitchell</div>
                  <div className="text-xs text-slate-500">Cardiologist</div>
                </div>
              </div>
              <div className="mt-3 rounded-2xl border border-blue-100 bg-blue-50 px-3 py-2 text-xs font-black text-blue-700">
                Today • 10:30 AM
              </div>
            </FloatingCard>

            <FloatingCard className="absolute right-[5%] top-[47%] w-[300px]">
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-50 text-violet-600">
                  <Icon name="heart" className="h-6 w-6" />
                </div>
                <div>
                  <div className="text-sm font-black text-slate-950">Health summary</div>
                  <div className="text-xs text-slate-500">
                    Everything looks good
                  </div>
                </div>
              </div>
              <svg className="mt-4 h-12 w-full" viewBox="0 0 280 55" fill="none">
                <path
                  d="M0 35 C22 35 20 12 43 12 C65 12 65 42 88 42 C112 42 114 18 138 18 C163 18 161 39 185 39 C210 39 210 10 235 10 C258 10 260 30 280 30"
                  stroke="blue"
                  strokeWidth="3"
                  strokeLinecap="round"
                  opacity="0.9"
                />
              </svg>
            </FloatingCard>

            <div className="absolute left-[10%] bottom-[23%] hidden h-40 w-40 rounded-full border border-blue-100 bg-white/70 backdrop-blur-xl xl:block">
              <div className="flex h-full items-center justify-center text-blue-700">
                <Icon name="shield" className="h-16 w-16" />
              </div>
            </div>

            <div className="mt-auto grid grid-cols-3 gap-5 border-t border-slate-200/80 pt-8">
              <HeroFeature
                icon="shield"
                title="Secure care"
                text="Your account and visit details stay protected."
              />
              <HeroFeature
                icon="users"
                title="Trusted doctors"
                text="Connect with verified healthcare professionals."
              />
              <HeroFeature
                icon="clock"
                title="Fast booking"
                text="Schedule visits in minutes, anytime."
              />
            </div>
          </div>
        </section>

        {/* RIGHT SIGN IN SIDE */}
        <section className="relative h-screen overflow-y-auto px-5 sm:px-8 lg:col-span-5 lg:px-10">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(14,165,233,0.13),transparent_35%),radial-gradient(circle_at_bottom_left,rgba(124,58,237,0.10),transparent_30%)]" />

          <div className="relative flex min-h-full items-center justify-center py-8">
            <div className="w-full max-w-[520px]">
            {/* mobile brand */}
            <div className="mb-8 flex items-center justify-center gap-3 lg:hidden">
              <img
                src="/images/logo.png"
                alt="ThePulseCare"
                className="h-12 w-auto object-contain"
              />
              <div>
                <div className="text-xl font-extrabold text-slate-950">
                  ThePulseCare
                </div>
                <div className="text-xs text-slate-500">Patient Portal</div>
              </div>
            </div>

            <div className="overflow-hidden rounded-[32px] border border-white/80 bg-white/90 shadow-[0_24px_80px_rgba(15,23,42,0.13)] backdrop-blur-xl">
              <div className="p-7 sm:p-9">
                <div>
                  <div className="inline-flex items-center gap-2 rounded-full border border-sky-100 bg-sky-50 px-3 py-1 text-xs font-bold text-sky-700">
                    <span className="h-2 w-2 rounded-full bg-emerald-500" />
                    Secure patient access
                  </div>

                  <h2 className="mt-5 text-4xl font-black tracking-tight text-slate-950">
                    Welcome back
                  </h2>
                  <p className="mt-3 max-w-sm text-base leading-7 text-slate-500">
                    Sign in to manage appointments, records, forms, invoices,
                    and online consultations.
                  </p>
                </div>

                <form onSubmit={onSubmit} className="mt-8 space-y-5">
                  {error ? (
                    <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4">
                      <div className="text-sm font-semibold text-rose-700">
                        {error}
                      </div>
                    </div>
                  ) : null}

                  {success ? (
                    <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4">
                      <div className="text-sm font-semibold text-emerald-700">
                        {success}
                      </div>
                    </div>
                  ) : null}

                  <Field label="Email address">
                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                        <Icon name="mail" className="h-5 w-5" />
                      </span>
                      <input
                        value={form.email}
                        onChange={(e) => {
                          setForm((p) => ({ ...p, email: e.target.value }));
                          setError("");
                        }}
                        type="email"
                        className={inputWithIcon}
                        placeholder="Enter your email address"
                        required
                        disabled={isLoading}
                      />
                    </div>
                  </Field>

                  <Field
                    label="Password"
                    right={
                      <Link
                        to={`/forgot-password${form.email ? `?email=${encodeURIComponent(form.email.trim())}` : ""}`}
                        className="text-sm font-bold text-primary hover:underline"
                      >
                        Forgot password?
                      </Link>
                    }
                  >
                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                        <Icon name="lock" className="h-5 w-5" />
                      </span>

                      <input
                        value={form.password}
                        onChange={(e) => {
                          setForm((p) => ({ ...p, password: e.target.value }));
                          setError("");
                        }}
                        type={showPw ? "text" : "password"}
                        className={classNames(inputWithIcon, "pr-14")}
                        placeholder="Enter your password"
                        required
                        minLength="6"
                        disabled={isLoading}
                      />

                      <button
                        type="button"
                        onClick={() => setShowPw((s) => !s)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-xl p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 disabled:opacity-50"
                        title={showPw ? "Hide password" : "Show password"}
                        disabled={isLoading}
                      >
                        <Icon
                          name={showPw ? "eyeOff" : "eye"}
                          className="h-5 w-5"
                        />
                      </button>
                    </div>
                  </Field>

                  <div className="flex items-center justify-between gap-4">
                    <label className="flex cursor-pointer items-center gap-3">
                      <input
                        type="checkbox"
                        className="h-4 w-4 rounded border-slate-300 text-primary focus:ring-primary"
                        checked={form.remember}
                        onChange={(e) =>
                          setForm((p) => ({
                            ...p,
                            remember: e.target.checked,
                          }))
                        }
                        disabled={isLoading}
                      />
                      <span className="text-sm font-semibold text-slate-700">
                        Remember me
                      </span>
                    </label>
                  </div>

                  <button
                    type="submit"
                    className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-gradient-to-r from-blue-600 via-sky-500 to-cyan-500 px-6 py-4 text-sm font-extrabold text-white shadow-[0_16px_40px_rgba(37,99,235,0.28)] transition hover:-translate-y-0.5 hover:shadow-[0_20px_50px_rgba(37,99,235,0.34)] disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <svg
                          className="h-5 w-5 animate-spin text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                        Signing in...
                      </>
                    ) : (
                      <>
                        Sign in
                        <Icon
                          name="arrowRight"
                          className="h-5 w-5 transition group-hover:translate-x-1"
                        />
                      </>
                    )}
                  </button>

                  <div className="pt-1 text-center text-sm text-slate-500">
                    Don&apos;t have an account?{" "}
                    <Link
                      to="/signup"
                      className="font-extrabold text-primary hover:underline"
                    >
                      Create account
                    </Link>
                  </div>
                </form>
              </div>

              <div className="border-t border-slate-100 bg-slate-50/80 px-7 py-5 sm:px-9">
                <div className="flex items-center gap-3">
                  <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white text-slate-500 shadow-sm">
                    <Icon name="shield" className="h-5 w-5" />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-slate-800">
                      Secure login
                    </div>
                    <div className="mt-0.5 text-xs leading-5 text-slate-500">
                      We use secure authentication to protect your health
                      information and appointment data.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-6 text-center text-xs text-slate-400">
              By signing in, you agree to ThePulseCare&apos;s Terms and Privacy
              Policy.
            </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}